<template>
  <div class="contact-tab">
    <h3>Learn more</h3>
    <p class="my-0">
      For more information, you may contact
      <a href="mailto:prosperafrica@usaid.gov">prosperafrica@usaid.gov</a>.
    </p>
    <p>
      Prosper Africa is a US government initiative established to increase trade
      and investment between African nations and the United States.
    </p>
    <p>
      <a href="https://www.prosperafrica.gov/about/" target="_blank"
        >Learn more here</a
      >
    </p>
    <h5 class="privacy-disclaimer">
      <inline-svg src="media/icons/custom/privacy.svg" />
      We handle your data with care. Please see our confidentiality and privacy
      terms <router-link to="/terms">here</router-link>
    </h5>
  </div>
</template>

<script>
export default {
  name: "contact-tab",
};
</script>

<style lang="scss" scoped>
.contact-tab {
  color: #fff;
  text-align: center;
  padding-bottom: 150px;
  a {
    color: #00a3ff;
  }
  h3 {
    color: #fff;
    font-size: 40px;
    margin-bottom: 27px;
  }
  p {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    font-family: Poppins, Helvetica, "sans-serif" !important;
  }
}
.privacy-disclaimer {
  text-align: center;
  color: #c8355d;
  font-size: 18px;
  font-weight: 600;
  margin-top: 30px;
  svg {
    vertical-align: bottom;
    margin-right: 5px;
  }
}
</style>
